import type { SVGProps } from "react";
const SvgHotelCrossed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
    aria-hidden="true"
    {...props}
  >
    <defs>
      <mask id="hotelCrossed_svg__a">
        <rect width="100%" height="100%" fill="#fff" />
        <rect width={20} height={20} x={32} y={32} rx={10} />
      </mask>
    </defs>
    <path
      fill="#96979A"
      d="M48 42.5h-2.5V25a2.5 2.5 0 0 0-2.5-2.5H33V15a2.5 2.5 0 0 0-3.89-2.08l-12.5 8.33a2.5 2.5 0 0 0-1.11 2.08V42.5H13a1.25 1.25 0 1 0 0 2.5h35a1.25 1.25 0 0 0 0-2.5M43 25v17.5H33V25zm-25-1.67L30.5 15v27.5H18zm10 4.17V30a1.25 1.25 0 1 1-2.5 0v-2.5a1.25 1.25 0 0 1 2.5 0m-5 0V30a1.25 1.25 0 1 1-2.5 0v-2.5a1.25 1.25 0 0 1 2.5 0m0 8.75v2.5a1.25 1.25 0 1 1-2.5 0v-2.5a1.25 1.25 0 0 1 2.5 0m5 0v2.5a1.25 1.25 0 1 1-2.5 0v-2.5a1.25 1.25 0 0 1 2.5 0"
      mask="url(#hotelCrossed_svg__a)"
    />
    <path
      stroke="#DE370C"
      strokeLinecap="round"
      strokeWidth={2}
      d="m46 38-8 8m8 0-8-8"
    />
  </svg>
);
export default SvgHotelCrossed;
